import $ from "jquery";
import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel2';
import { connect } from 'react-redux';
let rtlCheck = $("body").css("direction");

let falsy = false;
if(rtlCheck === "rtl"){
    falsy = true;
}
const options = {
    items: 1,
    nav: true,
    rtl: falsy,
    navText: ['<i class="la la-angle-left"></i>', '<i class="la la-angle-right"></i>'],
    navContainerClass: "nav-circle",
    dots: false,
    navElement: 'button',
    responsive: {
        0: {
            items: 1
        },
        600: {
            items: 1
        },
        1000: {
            items: 1
        }
    }
};
class Slider extends Component {
    render() {
        const {project} = this.props;
        return (
            <OwlCarousel options={options} className="image-carousel-one owl-carousel">
                {
                    Object.values(project).slice(6, 8).map((value, key) => {
                        return (
                        <div key={value.id} className="carousel-single">
                            <figure>
                                <img src={value.imgSrc} alt="" />
                            </figure>
                        </div>
                        )
                    })

                }
            </OwlCarousel>
        )
    }
}
const mapStateToProps = state => {
    return {
        project : state.project
    }
}
export default connect(mapStateToProps)(Slider);
